import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Button,
  Divider,
  Fade,
  Grid,
  Link,
  Snackbar,
  Typography,
} from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CustomTextField from "components/FormFields/CustomTextField";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingButton from "./LoadingButton";
import { SignUpPathEnum } from "constants/signUpPath";
import mailImg from "assets/img/mail.png";
import { StyledEmail, StyledFooterBox, StyledTitle } from "./styles";
import { FormContext } from "context/formContext";
import { useEmailVerifyMutation, useGetMealMeMenuDownloadMutation } from "api";
import Preloader from "./Preloader/Preloader";

const initialDataModel = {
  verificationCode: "",
};

const formSchema = yup.object().shape({
  verificationCode: yup.string().required("This field is required"),
});

const EmailVerify = () => {
  const { formData, updateFormData } = useContext(FormContext);
  const [showMessage, setShowMessage] = useState(false);

  const [loading, setLaoding] = useState(false);
  const [getMealMeMenuDownload, { isLoading }] =
    useGetMealMeMenuDownloadMutation();
  const [errorMessage, setErrorMessage] = useState("");
  const [verifyEmail] = useEmailVerifyMutation();
  const navigate = useNavigate();
  const location = useLocation();

  const formMethods = useForm({
    mode: "all",
    defaultValues: initialDataModel,
    resolver: yupResolver(formSchema),
  });

  const {
    formState: { isSubmitted },
    reset,
    getValues,
  } = formMethods;

  const handleSubmit = async (data) => {
    try {
      if (formData) {
        const dataObj = {
          storeId: formData?._id,
          googlePlaceId: formData?.googlePlaceId,
          email: formData?.email,
          verificationCode: data.verificationCode,
        };
        try {
          const res = await getMealMeMenuDownload(dataObj).unwrap();
          setErrorMessage("");
          // setId(res?.data?.body?.storeId || "");
          updateFormData(data);
          navigate(SignUpPathEnum.SIGN_UP_SUCCESS, {
            state: { id: res?.body?.storeId },
          });
        } catch (err) {
          setErrorMessage("Oops something went wrong!");
          console.log(err);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    const dataFromStorage = localStorage.getItem("formData");
    const parsedData = JSON.parse(dataFromStorage);
    if (parsedData) {
      const dataModel = {
        email: parsedData.email,
      };
      reset(dataModel);
    }
  }, [location]);

  const sendLink = async () => {
    setLaoding(true);

    try {
      const dataModel = {
        name: formData.name,
        restauratName: formData.restauratName,
        email: formData.email,
        addressInfo: formData.addressInfo,
      };
      await verifyEmail(dataModel).unwrap();
      setShowMessage(true);
      setTimeout(() => {
        setShowMessage(false);
      }, [3000]);
      setLaoding(false);
    } catch (error) {
      console.error(error);
      setLaoding(false);
    }
  };

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={12} lg={12} sm={12}>
        {isLoading || loading ? <Preloader overlay /> : null}
        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit(handleSubmit)}>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                justifyContent: "center",
                alignItems: "center",
                height: "600px",
              }}
            >
              <Box
                sx={{
                  height: "275px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box sx={{ width: "112px", height: "115px" }}>
                  <StyledEmail src={mailImg} alt={"Send Email"} />
                </Box>
                <Box sx={{ maxWidth: "500px" }}>
                  <StyledTitle sx={{ fontSize: "38px" }}>
                    Verify Your Email
                  </StyledTitle>
                  <Typography sx={{ fontSize: "18px" }}>
                    Enter the code sent to your email below to complete the
                    email verification!
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  height: "100px",
                }}
              >
                {errorMessage && (
                  <Typography color={"error"} align="left">
                    Wrong verification code
                  </Typography>
                )}

                <div
                  className={`message-container ${
                    showMessage ? "show fade-in" : ""
                  }`}
                >
                  <Typography
                    color="#4caf50"
                    variant="body1"
                    className="message-text"
                  >
                    A new code has been sent
                  </Typography>
                </div>

                <CustomTextField
                  label=""
                  placeholder={"Provide Verify Code"}
                  name="verificationCode"
                  sx={{ minWidth: "300px" }}
                />
              </Box>

              <Box sx={{ height: "48px" }}>
                <Typography>
                  Didn’t get a code?
                  <Button variant="text" onClick={sendLink}>
                    <b>Click to resend</b>
                  </Button>
                </Typography>
              </Box>
              {/* <Divider sx={{ width: "92px", my: 6 }} />
              <Typography
                sx={{
                  maxWidth: "376px",
                  color: "#A2A2A2",
                  fontSize: "12px",
                }}
              >
                Ad temporibus odit est repellendus harum est asperiores omnis ut
                deleniti nostrum ut voluptatem eveniet id doloremque
              </Typography> */}
            </Box>
            <StyledFooterBox sx={{ boxShadow: 4 }}>
              <Grid container m-0 p-0>
                <Grid item lg={6} md={12} xs={12} sm={12} m-0 p-0></Grid>
                <Grid item lg={6} md={12} xs={12} sm={12} m-0 p-0>
                  <Button variant="outlined" onClick={goBack}>
                    Back
                  </Button>
                  <Button variant="contained" type="submit">
                    Next
                  </Button>
                </Grid>
              </Grid>
            </StyledFooterBox>
          </form>
        </FormProvider>
      </Grid>
    </Grid>
  );
};

export default EmailVerify;
